import {Box, useBreakpointValue, VStack,} from "@chakra-ui/react";
import styles from "./styles";
import {GoogleAuth} from "../parts/GoogleAuth";
import {LoginForm} from "../../../components/forms";
import {LoginHeader} from "./index";

export const Login = () => {
    const isMobile = useBreakpointValue({ base: true, md : false, lg: false })

    return (
        <Box
            mt={isMobile ? '0' : '86px'}
            mx={'auto'}
            mb={isMobile ? '0' : '250px'}
            w={isMobile ? '90%' : '674px'}
            css={styles.loginContainer}>
            <VStack
                p={isMobile ? '16px': '53px'}
                pt={isMobile ? '24px' :'52px'}
                boxShadow={'0px 4px 4px 0px #00000040'}
                border={'1px solid #23262F99'}
                position={'relative'}
                overflow={'hidden'}
                alignItems={'center'}
                borderRadius={'32px'}>
                <LoginHeader />
                <LoginForm
                    isMobile={isMobile}/>
            </VStack>
            <GoogleAuth
                isMobile={isMobile}/>
        </Box>
    )
}

